/**
 * External Dependencies
 */
import React, { Component } from 'react';

/**
 * Internal Dependencies
 */
import Main from 'components/main';
import SignInForm from 'blocks/signin-form';

class SiteLogin extends Component {
	render() {
		return (
			<Main className='signin'>
				<SignInForm />
			</Main>
		);
	}
}

export default SiteLogin;
